import type { MidiaDaBibliotecaDto } from "@base/contracts";
import { cn } from "@/lib/utils";
import { MidiaAutenticada } from "../../referencias/presentation/midia-autenticada";

type Props = {
  readonly itens: readonly MidiaDaBibliotecaDto[];
  readonly selecionados: readonly string[];
  readonly onAlternar: (id: string) => void;
  readonly carregando?: boolean;
  readonly variante?: "compacto" | "grande";
};

export function PickerBiblioteca({
  itens,
  selecionados,
  onAlternar,
  carregando = false,
  variante = "compacto",
}: Props) {
  if (carregando) {
    return (
      <p className="text-sm text-muted-foreground" role="status">
        Carregando arquivos que servem para este post…
      </p>
    );
  }

  if (itens.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        Nenhum arquivo daqui serve para este tipo de post e essas redes.
      </p>
    );
  }

  return (
    <ul
      className={
        variante === "grande"
          ? "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5"
          : "grid grid-cols-3 gap-3"
      }
    >
      {itens.map((item) => {
        const ativo = selecionados.includes(item.id);
        return (
          <li key={item.id}>
            <button
              type="button"
              aria-pressed={ativo}
              aria-label={item.nome}
              onClick={() => onAlternar(item.id)}
              className={cn(
                "w-full cursor-pointer overflow-hidden rounded-lg border text-left transition-colors duration-200",
                ativo
                  ? "border-foreground ring-2 ring-ring/30"
                  : "border-input hover:border-foreground/25",
              )}
            >
              <div className="aspect-square bg-muted">
                <MidiaAutenticada
                  src={item.capaUrl}
                  tipo="image"
                  alt=""
                  className="size-full object-cover"
                />
              </div>
              <p className="truncate px-2 py-2 text-xs text-foreground">
                {item.nome}
              </p>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
